import { makeStateKey } from "@angular/core";

export const IS_INTERNAL_KEY = makeStateKey<string>('IS_INTERNAL_KEY');
